export enum ApiEndpoint {
  ACTIVATE_ACCOUNT = '/v1/member_profiles/{id}/activate_account/',
  AIRLINES = '/v1/airlines/',
  AIRPORTS = 'v1/expedited_immigration_airports/',
  ARTICLES = '/v1/articles/',
  AUTO_TRANSLATE = '/api/translate/?from=en&to={lang}',
  BENEFITS = '/v1/centurion_benefits/',
  BRANDS = '/v1/brands/',
  CENTURION_CARD_REQUEST = '/v1/centurion/card_request/',
  CENTURION_CARD_TYPES = '/v1/centurion/card_types/',
  CENTURION_PAGE = '/v1/centurion/page/{id}/',
  CENTURION_REFERRAL = '/v1/centurion/membership_referral/',
  CENTURION_SELF_REGISTER = '/v1/centurion/membership_request/',
  CENTURION_SITE_MAP = '/v1/centurion/site_map/',
  CHALLENGE_QUESTION = '/v1/member_profiles/{id}/challenge_question/',
  COUNTRIES = '/v1/countries/',
  COUNTRY_CALLING_CODES = '/v1/country_calling_codes/',
  CUSTOMISABLE_ASSETS = '/v1/customizable_assets/',
  CUSTOMISABLE_SECTIONS = '/v1/customisable_sections/{id}/',
  CUSTOMISABLE_VARIABLES = '/v1/customisable_variables/',
  DBSAMEX_CHECK_ELIGIBILITY = '/v1/dbs_check_eligibility/',
  DBSAMEX_SELF_REGISTER = '/v1/dbs_self_register/',
  DINING_AUTO_COMPLETE = '/api/autocomplete/dining/',
  DINING_BOOKING = '/v1/dining_bookings/',
  DINING_CATEGORIES = '/static-content/shared/{locale}/dining_categories.json',
  ESG_DINING_CATEGORIES = '/static-content/shared/{locale}/esg_dining_categories.json',
  DINING_CUISINES = '/static-content/shared/{locale}/dining_cuisines.json',
  DINING_ATTRIBUTES = '/static-content/shared/common/dining_oss_mh_attribute_mapping.json',
  DINING_HOT_TABLE = '/v1/dining_hot_tables/{id}/',
  DINING_HOT_TABLE_BOOKINGS = '/v1/dining_hot_table_bookings/',
  DINING_HOT_TABLE_BOOKINGS_ORDER = '/v1/dining_hot_table_bookings/{id}/order/',
  DINING_MEMBER_BENEFITS = '/static-content/shared/{locale}/dining_member_benefits.json',
  DINING_PRE_BOOKING = '/v1/dining_sub_bookings/',
  DINING_REQUEST = '/v1/dining_request_table/',
  DINING_REQUEST_TABLE = '/v1/dining_request_table/',
  DINING_SEARCH = '/api/search/dining/',
  DINING_LANDING_SEARCH = '/api/search/dining/landing/',
  ELIGIBILITY_CHECK = '/v1/eligibility_check/',
  ENTERTAINMENT_ARTISTS = '/v1/entertainment_artists/',
  ENTERTAINMENT_EVENTS = '/v1/entertainment_events/{id}/',
  ENTERTAINMENT_EVENTS_VENUES = '/v1/entertainment_events/{event_id}/venues/',
  ENTERTAINMENT_EVENTS_VENUE_PERFORMANCES = '/v1/entertainment_events/{event_id}/performances/?venue={venue_id}',
  ENTERTAINMENT_PERFORMANCES = '/v1/entertainment_performances/{id}/',
  ENTERTAINMENT_REQUEST = '/v1/entertainment_request/',
  ENTERTAINMENT_TICKET_BOOKINGS = '/v1/entertainment_ticket_bookings/',
  ENTERTAINMENT_TICKET_BOOKINGS_ORDER = '/v1/entertainment_ticket_bookings/{id}/order/',
  ENTERTAINMENT_TICKET_TYPES = '/v1/entertainment_ticket_types/{id}/',
  EXPEDITED_IMMIGRATION_REQUEST = '/v1/expedited_immigration_briefings/',
  EXTERNAL_OR_CLIENT_VERIFIED_ELIGIBILITY = '/v1/external_or_client_verified_eligibility/',
  GENERIC_SELF_REGISTER = '/v1/self_register/',
  GUIDES = '/v1/tags/guides/',
  REF1_CHECK_ELIGIBILITY = '/v1/ref1_check_eligibility/',
  REF1_SELF_REGISTER = '/v1/ref1_self_register/',
  INSPIRATIONS = '/v1/inspiration-contents/',
  INSPIRATION_FORMATS = '/v1/inspiration-formats/',
  INTERNATIONAL_REGIONS = '/v1/international_regions/',
  LIMOUSINE_REQUEST = '/v1/limousine_briefings/',
  LIMOUSINE_REQUEST_V2 = '/v2/limousine_briefings/',
  MANAGER_SPECIAL_REQUEST = '/v1/concierge_briefings/',
  MASTERCARD_SELF_REGISTER = '/v1/mastercard_self_register/',
  MEMBER_ACTIVITY = '/v1/member_activity/',
  MEMBER_ACTIVITY_V2 = '/v2/member_activity/',
  MEMBER_BENEFITS = '/v1/member_benefits/{id}/',
  MEMBER_BENEFITS_PROMOTIONAL_BANNER = '/v1/member_benefits_promotional_banner/',
  MEMBER_BENEFIT_GENERATE_CODE = '/v1/member_benefits/{id}/generate_code/',
  MEMBER_BENEFIT_JOIN_WAITING_LIST = '/v1/member_benefits/{id}/join_waiting_list/',
  MEMBER_BENEFIT_REDEMPTIONS = '/v1/member_benefit_redemptions_tm_activity/',
  MEMBER_EVENTS = '/v1/member_events/{id}/',
  MEMBER_EVENTS_BOOKINGS = '/v1/member_events_bookings/',
  MEMBER_EVENTS_BOOKINGS_ORDER = '/v1/member_events_bookings/{id}/order/',
  MEMBER_EVENTS_DATES = '/v1/member_events_dates/{id}/',
  MEMBER_EVENTS_SUBSCRIPTION = '/v1/member_events_subscriptions/',
  MEMBER_LOYALTY = 'v1/member_loyalty/',
  MEMBER_PREFERENCES = '/v1/member_preferences/',
  MEMBER_PREFERENCES_DINING = '/v1/member_preferences/dining/',
  MEMBER_PREFERENCES_HOTEL = '/v1/member_preferences/hotels/',
  MEMBER_PROFILES = '/v1/member_profiles/{id}/',
  MEMBER_PROFILE_ADDRESS = '/v1/member_addresses/',
  MEMBER_PROFILE_EMAIL = '/v1/member_profiles/{id}/change_email/',
  MEMBER_PROFILE_PASSWORD = '/v1/member_profiles/{id}/change_password/',
  MEMBER_PROFILE_PAYMENT_CARD = '/v1/cards/',
  MEMBER_PROFILE_PHONE_NUMBER = '/v1/member_phone_numbers/',
  MEMBER_PROFILE_SPECIAL_OCCASION = '/v1/member_special_occasions/',
  MEMBER_PROFILE_TRAVELLER = '/v1/member_travellers/',
  NEW_MEMBER_REGISTRATION = '/v1/member_acquisition/',
  PARTNERS = '/v1/partners/',
  PREBOOK_HOTELS = 'v1/hotel/cancellation_policy/',
  PUBLICATIONS = '/v1/publications/',
  PRELOGIN_PUBLICATIONS = '/v1/pre-login-publications/',
  PRELOGIN_ARTICLES = '/v1/pre-login-articles/',
  REQUEST_MANAGEMENT_PACKAGES = '/v1/request_management/packages/',
  PACKAGE_PURCHASE_REQUEST = '/v1/request_management/purchase_requests/',
  REQUEST_TYPES = '/v1/request_management/request_types/',
  MEMBER_PACKAGE_REQUEST = '/v1/request_management/package_requests/',
  REGISTRATION = '/v1/registration/',
  REGISTRATION_SECURITY_QUESTIONS = '/v1/registration/security_questions/',
  REGISTRATION_TOKEN = '/v1/registration-token/',
  RELATED_ARTICLES = '/v1/articles/{slug}/related/',
  RESET_PASSWORD = '/v1/member_profiles/reset_password/',
  RESTAURANTS = '/static-content/shared/{locale}/dining/{id}.json',
  SEARCH = '/v1/{module}_autocomplete/',
  SELF_REGISTRATION_SITES = '/v1/self_registration_sites/',
  SET_NEW_PASSWORD = '/v1/member_profiles/{id}/set_new_password/',
  SITE_CONFIG = '/v1/site_fe_config/',
  SITE_CONFIGURATION = '/v1/site_configuration/',
  SITE_CSS_SETTINGS = '/v1/site_css_settings/',
  SITE_ADMIN_CSS_SETTINGS = '/static/design-admin/css/',
  TAGS = '/v1/tags/',
  THREEDS_CHALLENGE = '/v1/payment/authorise/3ds2/',
  THREEDS_FINGERPRINT = '/v1/payment/fingerprint/3ds2/',
  THREEDS_NOTIFICATION = '/v1/payment_hooks/adyen_3ds2_notification/',
  THREEDS_REDIRECT = '/v1/payment/authorise/3ds1/',
  TOKENISER_CREDENTIALS = '/v1/tokenizer-credentials/',
  TRAVEL_AUTOSUGGEST = '/api/autocomplete/{travelType}s/',
  TRAVEL_BOOKINGS = '/v1/travel_bookings/',
  TRAVEL_BOOKINGS_CARD_TYPES = '/v1/payment_card_types/',
  TRAVEL_BRIEFINGS = '/v1/travel_briefings/',
  TRAVEL_CAR_CATEGORIES = '/static-content/shared/{locale}/car_categories.json',
  TRAVEL_CAR_HIRE_SEARCH = '/v1/car_hire_searches/',
  TRAVEL_CAR_HIRE_SEARCH_RESULT = '/v1/car_hire_search_results/',
  TRAVEL_CAR_HIRE_SUB_BOOKING = '/v2/car_hire_sub_bookings/',
  TRAVEL_FLIGHT_AIRLINES = '/v1/airlines/',
  TRAVEL_FLIGHT_CLASSES = '/v1/flight_classes/',
  TRAVEL_FLIGHT_FARE_FAMILIES = '/v2/flight_sub_bookings/fare_families/',
  TRAVEL_FLIGHT_FARE_FAMILY_SUB_BOOKING = '/v2/flight_fare_family_sub_bookings/',
  TRAVEL_FLIGHT_SEARCH = '/api/search/flights/',
  TRAVEL_FLIGHT_SEARCH_RESULT = '/v1/flight_search_results/',
  TRAVEL_FLIGHT_SUB_BOOKING = '/v2/flight_sub_bookings/',
  TRAVEL_FLIGHT_SUB_BOOKING_PATCH_TRAVELLERS = '/v2/flight_sub_bookings/{id}/',
  TRAVEL_HOTEL_SUB_BOOKING_PATCH_TRAVELLERS = '/v2/hotel_sub_bookings/{id}/',
  TRAVEL_CAR_SUB_BOOKING_PATCH_TRAVELLERS = '/v2/car_hire_sub_bookings/{id}/',
  TRAVEL_HOTEL_AMENITIES = '/static-content/shared/{locale}/amenities.json',
  TRAVEL_HOTEL_MEAL_BASIS = '/static-content/shared/{locale}/meal_basis{version}.json',
  TRAVEL_HOTEL_RECOMMENDED = '/api/search/hotels/promoted/',
  TRAVEL_HOTEL_SEARCH = '/api/search/hotels/',
  TRAVEL_HOTEL_SEARCH_RESULT = '/static-content/shared/{locale}/hotels/{id}.json',
  TRAVEL_HOTEL_SUPPLIERS = '/v1/hotel-suppliers/same-room-required-configuration/',
  TRAVEL_HOTEL_SUB_BOOKING = '/v2/hotel_sub_bookings/',
  USER_AUTO_LOGIN = '/v1/login-via-token/',
  USER_LOGIN = '/v1/login/',
  USER_LOGOUT = '/v1/logout/',
  USER_OAUTH_LOGIN_VIA_HASH = '/v1/login-via-hash/',
  USER_TOKEN_REFRESH = '/v1/token-refresh/',
  VISA_SELF_REGISTER = '/v1/visa_self_register/',
  DOWNLOAD_PUBLICATION = '/v1/publications/{slug}/download/',
  PRIMARY_INTERESTS = '/v1/interests/',
  MEMBER_PREFERENCES_POPUP = 'v1/member_preferences/popup/',
  ENTERTAINMENT_RANDOM_ARTISTS = '/v1/entertainment_artists/random/',
  BENEFIT_DETAIL = 'v1/corporate_benefits/',
  PRELOGIN_BENEFITS_AUTOCOMPLETE = '/v1/pre_login_member_benefit_autocomplete/',
  PRELOGIN_BENEFITS = '/v1/pre_login_member_benefits/',
  PRELOGIN_BENEFITS_FORMAT = '/v1/pre-login-member-benefit-formats/',
  PRELOGIN_FEATURED_INSPIRATION = '/v1/pre-login-inspiration-contents/',
  PRELOGIN_BENEFIT_DETAILS = '/v1/pre_login_member_benefits/{id}/',
  PRELOGIN_INSPIRATION_FORMAT = '/v1/pre-login-inspiration-formats/',
  VALUE_PROPOSITION_BANNER = '/v1/value_proposition_banner/',
  HOTEL_ADYEN_SUPPORT_INSTALMENT = '/v1/payment/support_instalments/',
}
